var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import styles from './Typography.module.css';
import { Space, Tooltip } from 'antd';
export var Typography = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'text' : _b, _c = _a.type, type = _c === void 0 ? 'default' : _c, _d = _a.weight, weight = _d === void 0 ? 400 : _d, tooltip = _a.tooltip, tooltipIcon = _a.tooltipIcon, className = _a.className, htmlProps = __rest(_a, ["children", "variant", "type", "weight", "tooltip", "tooltipIcon", "className"]);
    return (_jsx(Tooltip, __assign({ title: tooltip, placement: "topLeft", className: tooltip && styles.tooltip }, { children: _jsxs(Space, { children: [_jsx("p", __assign({}, htmlProps, { className: clsx(styles.t, styles[variant], styles[type], styles["w".concat(weight)], className) }, { children: children }), void 0), tooltipIcon] }, void 0) }), void 0));
};
